import { Icon as BlueIcon } from '@blueprintjs/core';
import { Text as AppText } from '@components';
import { UnstyledButton } from '@mantine/core';
import COLORS_FLAT from '@styles/colors/themes/beam/beam-flat';
import { cx } from '@utils/cx';
import { setAttr } from '@utils/setAttr';
import { useState } from 'react';
import styled from 'styled-components';

interface IDataSectionProps extends React.HTMLProps<HTMLDivElement> {
  title: string;
}
function DataSection(props: IDataSectionProps) {
  const { children, title, className = '', ...rest } = props;
  const [open, setOpen] = useState(false);
  return (
    <div
      className={cx('no-transitions', className)}
      data-active={open}
      {...rest}
    >
      <UnstyledButton
        data-active={open}
        className={cx('new-icon', 'Head')}
        onClick={() => setOpen(!open)}
      >
        <AppText text="h400" textColor="n800">
          {title}
        </AppText>
        <BlueIcon
          icon={open ? 'chevron-down' : 'chevron-right'}
          color={COLORS_FLAT.n600}
        />
      </UnstyledButton>

      <div className="ItemBody" hidden={setAttr(!open)}>
        {open && children}
      </div>
    </div>
  );
}

export default styled(DataSection)`
  margin-top: 8px;
  border: 1px solid #e6e8f0;
  border-radius: 4px;

  &[data-active='true'] {
    display: flex;
    flex-direction: column;
    row-gap: 24px;
  }

  .ItemBody {
    padding: 0 16px;
  }
  &[data-active='true'] .ItemBody {
    padding-bottom: 16px;
  }

  .Head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 16px;
    cursor: pointer;
    width: 100%;

    &[data-active='true'] {
      padding-bottom: 0;
    }
  }
`;
